export const TableBody = ({ children }) => {
  return <tbody className="text-gray-700 bg-white">{children}</tbody>;
};
